import React from 'react';
import RecommendedProducts from './RecommendedProducts';

/**
 * Component for displaying trending products
 */
const TrendingProducts = ({ limit = 10, days = 7 }) => {
  return (
    <div className="py-8">
      <RecommendedProducts 
        type="trending" 
        limit={limit}
      />
    </div>
  );
};

export default TrendingProducts;

